import { render } from "./DefaultLayoutComponent.vue?vue&type=template&id=303a17ab"
import script from "./DefaultLayoutComponent.vue?vue&type=script&lang=js"
export * from "./DefaultLayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sistemas\\CredenciamentoSUS\\aplicacao\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__